import { useRouter } from 'next/router';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';

import PreviousRouteContext from './PreviousRouteContext';

const PreviousRouteContextProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const router = useRouter();
  const ref = useRef<string | null>(null);
  const { Provider } = PreviousRouteContext;

  useEffect(() => {
    // https://github.com/vercel/next.js/discussions/36723
    const handleRouteChange = () => {
      ref.current = router.asPath;
    };

    router.events?.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events?.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  return <Provider value={ref}>{children}</Provider>;
};

export default PreviousRouteContextProvider;
